import { apiRequest } from "../client/apiClient";
import { retryRequest } from "../helpers/retryRequest";

export async function fetchValues(searchString) {
  return retryRequest(() =>
    apiRequest(`/values${searchString ? `?${searchString}` : ``}`),
  );
}

export async function saveValue(value) {
  return retryRequest(() =>
    apiRequest("/value/add", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(value),
    }),
  );
}

export async function editValue(value) {
  return retryRequest(() =>
    apiRequest(`/value/edit/${value.valueCode}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(value),
    }),
  );
}
export async function deletValue(value) {
  return retryRequest(() =>
    apiRequest(`/value/delete/${value.valueCode}`, {
      method: "delete",
      headers: { "Content-Type": "application/json" },
    }),
  );
}
